import { CouponItem } from 'features/coupons/types/coupons.types'
import { useEffect } from 'react'
import { parseISO } from 'libs/dates'
import { FieldValues, UseFormReset } from 'libs/form'

interface UsePopulateCouponProps {
	coupon: CouponItem | undefined
	reset: UseFormReset<FieldValues>
}

export const usePopulateCoupon = ({ coupon, reset }: UsePopulateCouponProps) => {
	useEffect(() => {
		if (coupon) {
			reset({
				code: coupon?.code,
				price_discount_value: coupon?.price_discount?.value,
				price_discount_is_percentage: coupon?.price_discount?.is_percentage,
				booking_window_start: parseISO(coupon.booking_window_start),
				booking_window_end: parseISO(coupon.booking_window_end),
				// Legacy coupons have null dates: leave the pickers empty so save is blocked until set
				valid_from: coupon.valid_from ? parseISO(coupon.valid_from) : null,
				valid_until: coupon.valid_until ? parseISO(coupon.valid_until) : null,
				is_active: !!coupon.is_active,
				booth_type: coupon.booth_type,
				rental: coupon.rental,
				max_uses: coupon.max_uses ?? ''
			})
		}
	}, [coupon])
}
